module.exports = __webpack_public_path__ + "static/media/m6tj168.3ffdc380.png";